// removed by extract-text-webpack-plugin
module.exports = {"profileDataContainer":"ProfileData__profileDataContainer___3erwS","userDescription":"ProfileData__userDescription___6Qa5d","userInfo":"ProfileData__userInfo___3P6cS","blackHeader":"ProfileData__blackHeader___1y6GZ","dataInSmallScreens":"ProfileData__dataInSmallScreens___1ra4L","dataInBigScreens":"ProfileData__dataInBigScreens___3kT2G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileData/ProfileData.scss
// module id = 1517
// module chunks = 0